import camelcaseKeys from 'camelcase-keys';

/**
 * Creates the object of a Model from an Object
 * @param {Object} model - The model with the initial values
 * @param {Object} obj - The object with the key/values to create the model
 *                          the keys are created in camel case
 * @return {Object} the new model object
 */
const createModelInstance = (model, obj) => {
    const newObj = camelcaseKeys(obj, { deep: true });
    const modelKeys = Object.keys(model);
    // Loops trough the keys in the new object
    for (const key in newObj) {
        // If the model has the key then assign the value to the key
        // The key should be an exact match
        if (modelKeys.indexOf(key) >= 0) {
            model[key] = newObj[key];
        }
    }
    return model;
};

export default createModelInstance;
